import React from "react";
import { useHistory } from "react-router-dom";
import { SpaceSearchPayload } from "../../components/SpaceSearchBar";
import SEO from "../../components/SEO/SEO";
import HeroSection from "./components/HeroSection";
import PillarsSection from "./components/PillarsSection";
import ShiftSection from "./components/ShiftSection";
import WhatIsSpaciaSection from "./components/WhatIsSpaciaSection";
import WhyChooseSection from "./components/WhyChooseSection";
import AudienceSection from "./components/AudienceSection";
import ExploreSection from "./components/ExploreSection";
import HowItWorksSection from "./components/HowItWorksSection";
import RoadmapSection from "./components/RoadmapSection";
import TrustSection from "./components/TrustSection";
import FaqSection from "./components/FaqSection";
import FinalCtaSection from "./components/FinalCtaSection";
import "./index.css";

export default function NewHomeScreen() {
  const history = useHistory();

  const handleSearch = (payload: SpaceSearchPayload) => {
    let dateParams = "";
    if (payload.dateRange) {
      if (payload.dateRange.startDate && payload.dateRange.endDate) {
        dateParams = `&startDate=${encodeURIComponent(payload.dateRange.startDate)}&endDate=${encodeURIComponent(payload.dateRange.endDate)}`;
      } else if (payload.dateRange.specificDate && payload.dateRange.specificDate.length > 0) {
        dateParams = `&specificDate=${encodeURIComponent(payload.dateRange.specificDate.join(","))}`;
      }
    }
    const catParam = payload.categoryId ? `&categoryId=${payload.categoryId}` : "";
    const subParam = payload.subcategoryId ? `&subCategoryId=${payload.subcategoryId}` : "";
    const queryText = payload.query || payload.location || "";
    const locParam = queryText ? `&query=${encodeURIComponent(queryText)}` : "";
    const filterParam = payload.searchFilter && payload.searchFilter !== "all" ? `&searchFilter=${encodeURIComponent(payload.searchFilter)}` : "";

    if (queryText || payload.searchFilter) {
      const searchFilters: any = {};
      const filterKey = payload.searchFilter || "all";
      if (queryText) {
        if (filterKey === "organizations") {
          searchFilters.hostOrgName = queryText;
        } else if (filterKey === "buildings") {
          searchFilters.buildingName = queryText;
        } else if (filterKey === "spaces") {
          searchFilters.spaceName = queryText;
        } else if (filterKey === "cities") {
          searchFilters.cityOrTown = queryText;
        } else if (filterKey === "countries") {
          searchFilters.country = queryText;
        } else {
          searchFilters.addressContains = queryText;
          searchFilters.buildingName = queryText;
          searchFilters.hostOrgName = queryText;
          searchFilters.spaceName = queryText;
          searchFilters.cityOrTown = queryText;
          searchFilters.country = queryText;
        }
      }
      if (payload.searchFilter) {
        searchFilters.searchFilter = payload.searchFilter;
      }
      if (payload.categoryId) {
        searchFilters.categoryId = parseInt(payload.categoryId, 10);
      }
      if (payload.subcategoryId) {
        searchFilters.subCategoryId = parseInt(payload.subcategoryId, 10);
      }
      localStorage.setItem("searchFilters", JSON.stringify(searchFilters));
    }

    history.push(
      `/workspaces-search?type=${encodeURIComponent(payload.type)}${catParam}${subParam}${locParam}${filterParam}${dateParams}`
    );
  };

  return (
    <div className="new-home-container min-h-screen flex flex-col">
      <SEO
        title="One Platform for Work • Stay • Play - SPACIA"
        description="SPACIA brings together flexible workspaces, quality accommodation and curated lifestyle experiences on a single platform."
      />

      <HeroSection onSearch={handleSearch} />
      <PillarsSection />
      <ShiftSection />
      <WhatIsSpaciaSection />
      <WhyChooseSection />
      <AudienceSection />
      <ExploreSection />
      <HowItWorksSection />
      <RoadmapSection />
      <TrustSection />
      <FaqSection />
      <FinalCtaSection />
    </div>
  );
}
